import React from 'react';

const MedicationDetailsModal = ({ medication, onClose, formatTo12Hour, onEdit }) => {
    if (!medication) return null;

    const parsedTimes = medication.times
        ? Array.isArray(medication.times)
            ? medication.times
            : JSON.parse(medication.times)
        : [];

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl"
                    aria-label="Close"
                >
                    ✕
                </button>

                {/* Header */}
                <h2 className="text-2xl font-semibold mb-6 text-center">Medication Details</h2>

                {/* Details */}
                <div className="space-y-4 text-sm text-gray-700">
                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Drug Name:</span>
                        <span>{medication.drug_name}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Dosage:</span>
                        <span>{medication.dosage}</span>
                    </div>

                    {medication.description && (
                        <div className="flex justify-between">
                            <span className="font-medium text-gray-500">Description:</span>
                            <span>{medication.description}</span>
                        </div>
                    )}

                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Prescribed By:</span>
                        <span>{medication.prescribing_doctor}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Condition:</span>
                        <span>{medication.condition_treated}</span>
                    </div>

                    {medication.instructions && (
                        <div className="flex justify-between">
                            <span className="font-medium text-gray-500">Instructions:</span>
                            <span className="text-right">{medication.instructions}</span>
                        </div>
                    )}

                    {medication.times && (
                        <div className="flex justify-between">
                            <span className="font-medium text-gray-500">Reminder:</span>
                            <span className="text-right">{parsedTimes.map(formatTo12Hour).join(', ')}</span>
                        </div>
                    )}

                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Start Date:</span>
                        <span>{new Date(medication.start_date).toLocaleDateString()}</span>
                    </div>

                    {medication.end_date && (
                        <div className="flex justify-between">
                            <span className="font-medium text-gray-500">End Date:</span>
                            <span>{new Date(medication.end_date).toLocaleDateString()}</span>
                        </div>
                    )}
                </div>

                {/* Edit Button */}
                <button
                    onClick={onEdit}
                    className="mt-6 w-full py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
                >
                    Edit Medication
                </button>
            </div>
        </div>
    );
};

export default MedicationDetailsModal;
